var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIdea = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#FBBB00",
    fillOpacity: 0.24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5792 28.8562H17.4459C16.8755 28.8562 16.4121 28.3928 16.4121 27.8224C16.4121 27.252 16.8755 26.7886 17.4459 26.7886H22.5792C23.1496 26.7886 23.613 27.252 23.613 27.8224C23.613 28.3928 23.1496 28.8562 22.5792 28.8562Z",
    fill: "#F1A501",
    stroke: "#2C4142",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0836 9V11.2102",
    stroke: "#F1A501",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7031 11.9762L13.266 13.5391",
    stroke: "#F1A501",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1484 11.9762L26.5856 13.5391",
    stroke: "#F1A501",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 19.1191L11.2102 19.1191",
    stroke: "#F1A501",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8535 19.1191L28.6433 19.1191",
    stroke: "#F1A501",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8399 26.8241H23.2209V25.719C23.2209 25.3269 23.3991 25.006 23.72 24.7921C25.3598 23.6514 26.4292 21.7264 26.4292 19.5875C26.4292 15.9514 23.3635 12.9927 19.6917 13.2065C16.5191 13.3848 13.9168 15.9158 13.6672 19.0885C13.489 21.4412 14.5941 23.5445 16.3408 24.7921C16.6617 25.006 16.8399 25.3625 16.8399 25.7546V26.8241Z",
    fill: "white",
    stroke: "#2C4142",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18 29C18 30.1071 18.8929 31 20 31C21.1071 31 22 30.1071 22 29",
    fill: "#F1A501"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18 29C18 30.1071 18.8929 31 20 31C21.1071 31 22 30.1071 22 29",
    stroke: "#2C4142",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIdea);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/idea.7854225787e62d641b4a92f95367e2d2.svg";